import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../common/auth/auth.guard';
import { ROUTES_URLS } from '../common/constants';
import { DocumentApprovalFlowGuard } from '../common/permissions/document-approval-flow.guard';
import { PermissionGuard } from '../common/permissions/permissions.guard';
import { OverviewV2Guard } from '../overview-v2/guards/overview-v2.guard';

import { FeatureGuard } from './guards/feature.guard';
import { ShellResolver } from './shell-resolver.guard';
import { ShellComponent } from './shell.component';

// noinspection TypeScriptValidateTypes
const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard],
    resolve: { ShellResolver },
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-dashboard' },
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'overview',
        canActivate: [ OverviewV2Guard ],
        loadChildren: () => import('../overview-v2/overview-v2.module').then(m => m.OverviewV2Module)
      },
      {
        path: 'incomplete-profiles',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-view-incomplete-registrations' },
        loadChildren: () => import('../incomplete-registrations/incomplete-registrations.module').then(m => m.IncompleteRegistrationsModule)
      },
      {
        path: 'training-slots',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-view-training-slots' },
        loadChildren: () => import('../training-slots/training-slots.module').then(m => m.TrainingSlotsModule)
      },
      {
        path: 'approve-documents',
        canActivate: [PermissionGuard, DocumentApprovalFlowGuard],
        data: {permission: 'admin-view-lead-profile' },
        loadChildren: () => import('../approve-documents/approve-documents.module').then(m => m.ApproveDocumentsModule)
      },
      {
        path: ROUTES_URLS['document-transcription-v2'],
        canActivate: [DocumentApprovalFlowGuard],
        data: {permission: 'admin-view-lead-profile' },
        loadChildren: () => import('../overview-v2/document-transcription-v2/document-transcription-v2.module').then(m => m.DocTranscriptionV2Module)
      },
      {
        path: 'reporting',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-reporting' },
        loadChildren: () => import('../reporting/reporting.module').then(m => m.ReportingModule)
      },
      {
        path: 'download-history',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-download-list-for-solution' },
        loadChildren: () => import('../download-history/download-history.module').then(m => m.DownloadHistoryModule)
      },
      {
        path: 'download-data',
        children: [
          {
            path: 'all-captains',
            canActivate: [PermissionGuard],
            data: { permission: 'download-data' },
            loadChildren: () => import('../download-data/download-data.module').then(m => m.DownloadDataModule)
          },
          {
            path: 'help-leads',
            canActivate: [PermissionGuard],
            data: { permission: 'download-data' },
            loadChildren: () => import('../download-data-help-leads/download-data-help-leads.module').then(m => m.DownloadDataHelpLeadsModule)
          },
          {
            path: 'optional-docs',
            canActivate: [PermissionGuard],
            data: { permission: 'download-data' },
            loadChildren: () => import('../download-data-optional-docs/download-data-optional-docs.module').then(m => m.DownloadDataOptionalDocsModule)
          },
          {
            path: 'captain-docs',
            canActivate: [PermissionGuard],
            data: { permission: 'download-excel-url' },
            loadChildren: () => import('../download-data-captain-docs/download-data-captain-docs.module').then(m => m.DownloadDataCaptainsModule)
          },
          {
            path: 'export-status',
            canActivate: [PermissionGuard],
            data: { permission: 'admin-view-captain-creation-status' },
            loadChildren: () => import('../download-data-creation-status/download-data-creation-status.module').then(m => m.DownloadDataCreationStatusModule)
          }
        ]
      },
      {
        path: 'find-a-captain',
        canActivate: [PermissionGuard],
        data: { permission: 'find-a-captain' },
        loadChildren: () => import('../find-a-captain/find-a-captain.module').then(m => m.FindACaptainModule)
      },
      {
        path: 'user-management',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-manage-users' },
        loadChildren: () => import('../user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'replicate-city',
        canActivate: [PermissionGuard],
        data: { permission: 'replicate-city' },
        loadChildren: () => import('../replicate-city/replicate-city.module').then(m => m.ReplicateCityModule)
      },
      {
        path: 'add-captain',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-add-captain' },
        loadChildren: () => import('../add-captain/add-captain.module').then(m => m.AddCaptainModule)
      },
      {
        path: 'support',
        loadChildren: () => import('../support/support.module').then(m => m.SupportModule)
      },
      {
        path: 'add-lead',
        canActivate: [PermissionGuard],
        data: { permission: 'admin-add-captain' },
        loadChildren: () => import('../add-lead/add-lead.module').then(m => m.AddLeadModule)
      },
      {
        path: 'cms',
        canActivate: [PermissionGuard],
        // Might need another permission or no permission and let it be handled in children
        data: { permission: 'admin-view-city-document' },
        loadChildren: () => import('../cms/cms.module').then(m => m.CmsModule)
      }
    ]
  }
];

export const ROUTES = RouterModule.forChild(routes);
